/* shop/MiniBasket.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	component_subscribe,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	noop,
	safe_not_equal,
	set_data_dev,
	space,
	src_url_equal,
	text,
	validate_slots,
	validate_store
} from "svelte/internal";

import { basketPrice, basketItemsCount } from "./basketStore";
import basketImage from "./basket.svg";
const file = "shop/MiniBasket.svelte";

// (20:8) {#if $basketItemsCount > 0}
function create_if_block(ctx) {
	let span;
	let t;

	const block = {
		c: function create() {
			span = element("span");
			t = text(/*$basketItemsCount*/ ctx[0]);
			attr_dev(span, "class", "header--basketLabel");
			add_location(span, file, 20, 12, 488);
		},
		m: function mount(target, anchor) {
			insert_dev(target, span, anchor);
			append_dev(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$basketItemsCount*/ 1) set_data_dev(t, /*$basketItemsCount*/ ctx[0]);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(span);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(20:8) {#if $basketItemsCount > 0}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let nav;
	let a;
	let img;
	let img_src_value;
	let t;
	let if_block = /*$basketItemsCount*/ ctx[0] > 0 && create_if_block(ctx);

	const block = {
		c: function create() {
			nav = element("nav");
			a = element("a");
			img = element("img");
			t = space();
			if (if_block) if_block.c();
			if (!src_url_equal(img.src, img_src_value = basketImage)) attr_dev(img, "src", img_src_value);
			attr_dev(img, "alt", "Košík");
			add_location(img, file, 18, 8, 402);
			attr_dev(a, "href", /*url*/ ctx[1]);
			add_location(a, file, 17, 4, 377);
			attr_dev(nav, "class", "header--basket");
			add_location(nav, file, 16, 0, 344);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, nav, anchor);
			append_dev(nav, a);
			append_dev(a, img);
			append_dev(a, t);
			if (if_block) if_block.m(a, null);
		},
		p: function update(ctx, [dirty]) {
			if (/*$basketItemsCount*/ ctx[0] > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(a, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(nav);
			if (if_block) if_block.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let $basketItemsCount;
	validate_store(basketItemsCount, 'basketItemsCount');
	component_subscribe($$self, basketItemsCount, $$value => $$invalidate(0, $basketItemsCount = $$value));
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('MiniBasket', slots, []);
	const dataElm = document.getElementById("miniBasket");
	const url = dataElm.dataset.url;
	const writable_props = [];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<MiniBasket> was created with unknown prop '${key}'`);
	});

	$$self.$capture_state = () => ({
		basketPrice,
		basketItemsCount,
		basketImage,
		dataElm,
		url,
		$basketItemsCount
	});

	return [$basketItemsCount, url];
}

class MiniBasket extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, {});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "MiniBasket",
			options,
			id: create_fragment.name
		});
	}
}

export default MiniBasket;